module.exports = __webpack_public_path__ + "static/media/codeCoin.6b86b1f5.png";